import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { ErrorComponent } from '@angular/synthrone-design/components';

@Component({
  selector: 'app-add-update-font-form',
  templateUrl: './add-update-font-form.component.html',
  styleUrls: ['./add-update-font-form.component.scss']
})
export class AddUpdateFontFormComponent implements OnInit {

  namePattern: RegExp = /^[A-Za-z][A-Za-z0-9\- ]*[A-Za-z0-9]?$/;
  newName: string;
  submitClicked: boolean = false;
  isEdit: boolean = false;
  clients: Array<{
    name: string,
    planet: string
  }> = [];
  fontClients: Array<string> = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddUpdateFontFormComponent>,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.newName = <string>this.data.oldName;
    this.clients = this.data.clients.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
    this.fontClients = this.data.fontClients.map((client) => {
      return client.planet;
    });
    if (this.data.dataId) {
      this.isEdit = true;
    }
  }

  closeWindow = (param = null): void => {
    this.dialogRef.close(param);
  };

  canSubmit = (): Boolean => {
    return (!(this.newName.length < 3) && (this.newName.match(this.namePattern) && this.newName.match(this.namePattern)[0] === this.newName));
  };

  submitFn = (): void => {
    this.submitClicked = true;
    this.data.callback(this.newName, this.fontClients).catch((error: any) => {
      this.submitClicked = false;
      this.showError(error);
      return Observable.throw(error)
    }
    ).subscribe((response) => {
      this.closeWindow(true);
    });
  };

  inputKeyUp = (event: KeyboardEvent): void => {
    if (event.key === 'Enter' && this.canSubmit()) {
      this.submitFn();
    }
  };

  showError(message: string): Observable<any> {
    let dialogRef = this.dialog.open(ErrorComponent, {
      data: {
        message: message
      }
    });
    return dialogRef.afterClosed();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/add-update-font-form/add-update-font-form.component.ts